import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const AT: DeepPartial<Payments> = {
    showSnackbarOnResetPayment: {
        enabled: true,
    },
};
